export const rootState = {
  openTreasure: {
    shareId: "",
    isFirst: false,
    luckyValue: null,
  },
  grabbedGift: {
    giftCode: "",
    isSuccess: null,
    msg: "",
  },
  myStatus: {
    totalValue: 0,
    numOfDays: 0,
    periods: "",
    redeemDate: "",
    button: 5, //5时隐藏按钮
    helpRecordDTOList: [],
  },
  myPrize: {
    list: null,
  },
  prizeList: [],
}

export default function reducer(state = rootState, action) {
  console.log(action)
  switch (action.type) {
    case "PUT_TREASURE":
      return {
        ...state,
        openTreasure: action.payload,
      }
    case "PUT_MY_GRABBED_GIFT":
      return {
        ...state,
        grabbedGift: action.payload,
      }
    case "PUT_MY_STATUS":
      return {
        ...state,
        myStatus: action.payload,
      }
    case "PUT_MY_PRIZE":
      return {
        ...state,
        myPrize: action.payload,
      }
    case "PUT_PRIZE_LIST":
      return {
        ...state,
        prizeList: action.payload,
      }
    case "TOGGLE_RESULT_MODAL":
      return {
        ...state,
        grabbedGift: {
          ...state.grabbedGift,
          isSuccess: null,
        },
      }
    case "CHANGE_FIRST":
      return {
        ...state,
        openTreasure: {
          ...state.openTreasure,
          isFirst: false,
        },
      }
    default:
      return state
  }
}
